import { useContext } from "react";
import Webcam from "react-webcam";
import { CameraScanChildProps } from "../../types/interfaces";
import { MEDIA_TYPES, MediaContext } from "../../utils/context/mediaContext";
import { LanguageContext } from "../../utils/context/languageContext";
import {  pauseIcon, voiceOverAssetsPath } from "../../utils/constants";
import SpecificButton from "../../atoms/specificButton/SpecificButton";
import { LanguageKeys } from "../../utils/languageKeys";
import { X } from "lucide-react";



function CameraScanChild({
  resetScan,
  loadingCam,
  onUserMedia,
  onPause,
  pause,
  onReScan,
  recordingStarted,
  startSendingVideoFrames,
  showPause,
  webcamRef,
  onUserMediaError,
  resetDetector,
  videoConstraints,
  webcamKey,
  faceDone,
  isScanning,
}: Omit<CameraScanChildProps, "config">) {
  const { media } = useContext(MediaContext) || {};
  const { translate } = useContext(LanguageContext) || {};

  return (
    <div className="App w-screen h-[100vh] relative common-ui-main" data-testid="camera-scan" data-scan-phase={faceDone ? "spinning" : recordingStarted ? "pose-detecting" : isScanning ? "starting" : "ready"}>
      <span
        onClick={() => {
          resetScan();
          resetDetector();
        }}
        className="fixed right-[20px] top-[20px] z-[999]"
      >
        <X className="text-[#fff]" />
      </span>

      <div className="w-full h-full overflow-hidden ">
        {media === MEDIA_TYPES.MOBILE && (
          <Webcam
            key={webcamKey}
            audio={false}
            ref={webcamRef}
            screenshotQuality={1}
            videoConstraints={videoConstraints}
            mirrored
            screenshotFormat="image/jpeg"
            onUserMedia={onUserMedia}
            onUserMediaError={onUserMediaError}
            style={{
              position: "fixed",
              top: 0,
              bottom: 0,
              zIndex: 0,
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
          />
        )}
      </div>

      <div className="fixed bottom-[30px] w-full z-[999] flex flex-col gap-4 items-center justify-center">
        {showPause && (
          <SpecificButton
            className="!w-[180px] !h-[40px] !py-[0]  mx-auto   "
            prefix={pauseIcon}
            buttonText={translate?.(LanguageKeys.pause)}
            buttonFunc={onPause}
            btnSecondary
          />
        )}

        {pause ? (
          <div>
            <SpecificButton
              className="!w-[180px] !h-[40px] !py-[0]  mx-auto"
              buttonText={translate?.(LanguageKeys.restart)}
              buttonFunc={onReScan}
              btnSecondary
            />
          </div>
        ) : !recordingStarted ? (
          <SpecificButton
            data-testid="start-scan-btn"
            className={`!w-[180px] !h-[40px] !py-[0]  mx-auto !bg-[#ffffff] !text-[#000000] ${
              loadingCam ? "!opacity-50" : ""
            }`}
            buttonText={translate?.(LanguageKeys.startScan)}
            buttonFunc={startSendingVideoFrames}
            disabled={loadingCam}
          />
        ) : null}
      </div>

      <audio
        id="audioElement"
        crossOrigin="anonymous"
        preload="auto"
        style={{
          position: "absolute",
          zIndex: -99999,
        }}
        src={`${voiceOverAssetsPath}scanAudioInstructions/silence.mp3`}
      />
    </div>
  );
}

export default CameraScanChild;
